import { Exclude, Expose, Transform, Type } from 'class-transformer';
import { SafeUrl } from '@angular/platform-browser';
import { InitializableEntity } from '@core/entities/_extra/intializable.entity';
import { PaginatedEntity } from '@core/entities/_extra';
import { DeletedStatus } from '@core/enums';

export class UserListEntity extends PaginatedEntity {
  @Type(() => UserEntity)
  @Expose({ name: 'member' })
  members: UserEntity[];
}

export class UserEntity extends InitializableEntity {
  id = 0;

  @Expose({ name: 'keycloak_id' })
  keycloakId: string;

  @Expose({ name: 'username' })
  userName: string;

  @Expose({ name: 'firstname' })
  firstName: string;

  @Expose({ name: 'lastname' })
  lastName: string;

  @Expose({ name: 'team_id' })
  teamId?: string;

  role: string;
  email: string;

  @Expose({ name: 'database_id' })
  databaseId?: number;

  @Expose({ name: 'clubName' })
  clubName?: string;
  street: string;
  moreInfo: string;
  city: string;
  zipCode: string;
  phone: string;
  country: string;
  birthDate: string;
  gender: string;
  addressLine: string;
  memberPhoto: boolean;

  @Expose({ name: 'member_id' })
  memberId: string;

  @Expose({ name: 'bd_notification' })
  bdNotification: string;

  @Expose({ name: 'share_birthday' })
  shareBirthday: number;

  @Expose({ name: 'allowAdvertis' })
  allowAdvertisement: number;

  headlineOption = 0;

  @Expose({ name: 'old_keyclock_id' })
  oldKeyClockId: string;

  @Expose({ name: 'login_status' })
  loginStatus: number;

  @Expose({ name: 'created_at' })
  createdAt: string;

  @Expose({ name: 'fcmtoken' })
  fcmToken: string;

  @Exclude()
  imageUrl?: SafeUrl;

  @Expose({ name: 'last_active_date' })
  lastActiveDate: string;

  @Expose({ name: 'deleted_user' })
  @Transform(({ value }) => value === DeletedStatus.Deleted, { toClassOnly: true })
  deleted = false;

  // Aux properties for the UI only
  isJubilee = false;
  isBirthday = false;
  name = '';

  constructor(values?: Partial<UserEntity>) {
    super(values);
    this.initEntity(values);
  }

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }
}
